import { type RouteRecordRaw } from 'vue-router'

import { useApplicationCfgStore } from '../applicationCfg/applicationCfg.store'

export const ConfigDevRouter: RouteRecordRaw[] = [
  {
    path: '/applicationConfig',
    component: async () => import('./ConfigDev.vue'),
    async beforeEnter() {
      await useApplicationCfgStore.getState().loadApplicationCfg()
    },
  },
]
